import type {
  AuthSession,
  AuthUser,
  ConsentDocumentText,
  ConsentDocumentView,
  ConsentRecordView,
} from '@alterium/shared';
import { api, setAccessToken } from './client';

export interface RegisterPayload {
  email: string;
  password: string;
  name?: string;
  referralCode?: string;
  acceptedConsents: Record<string, string>;
  locale?: string;
}

export const authApi = {
  consentDocuments: (locale: string) =>
    api.get<ConsentDocumentView[]>(`/consents/documents?locale=${encodeURIComponent(locale)}`),

  /** Полный текст одного документа. Язык выбирает сервер: перевода может не быть. */
  consentDocumentText: (type: string, locale: string) =>
    api.get<ConsentDocumentText>(`/consents/documents/${type}?locale=${encodeURIComponent(locale)}`),

  register: async (payload: RegisterPayload): Promise<AuthSession> => {
    const session = await api.post<AuthSession>('/auth/register', payload);
    setAccessToken(session.accessToken);
    return session;
  },

  login: async (email: string, password: string): Promise<AuthSession> => {
    const session = await api.post<AuthSession>('/auth/login', { email, password });
    setAccessToken(session.accessToken);
    return session;
  },

  logout: async (): Promise<void> => {
    await api.post('/auth/logout');
    setAccessToken(null);
  },

  verifyEmail: async (token: string): Promise<AuthSession> => {
    const session = await api.post<AuthSession>('/auth/verify-email', { token });
    setAccessToken(session.accessToken);
    return session;
  },

  resendVerification: (email: string) => api.post('/auth/resend-verification', { email }),
  forgotPassword: (email: string) => api.post('/auth/forgot-password', { email }),
  resetPassword: (token: string, password: string) =>
    api.post('/auth/reset-password', { token, password }),

  me: () => api.get<AuthUser>('/account'),
  consents: () => api.get<ConsentRecordView[]>('/consents'),
  acceptConsents: (acceptedConsents: Record<string, string>) =>
    api.post<ConsentRecordView[]>('/consents/accept', { acceptedConsents }),
};
